import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckBoxModule } from '../../../check-box/check-box.module';
import { ListModule } from '../../../list/list.module';
import { TypeUtilizationBoxComponent } from './type-utilization-box.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, ListModule, CheckBoxModule],
  declarations: [TypeUtilizationBoxComponent],
  exports: [TypeUtilizationBoxComponent],
})
export class TypeUtilizationBoxModule {}
